import {
  parsePhoneNumber,
  isPossiblePhoneNumber
} from 'react-phone-number-input'
import countryList from './countries.json'

const SPAIN = 'ES'

export const parsePhone = phone => {
  if (!phone || phone.trim() === '') {
    return { countryCode: SPAIN, nationalNumber: '' }
  }

  try {
    const parsed = parsePhoneNumber(phone)
    if (parsed) {
      return {
        countryCode: parsed.country || SPAIN,
        nationalNumber: parsed.nationalNumber || ''
      }
    }
  } catch {}

  // If the value doesn't parse, try to extract country from prefix
  const country = countryList.find(c => phone.startsWith(c.callingCode))
  if (country) {
    return {
      countryCode: country.code,
      nationalNumber: phone.substring(country.callingCode.length).trim()
    }
  }

  return {
    countryCode: SPAIN,
    nationalNumber: phone.replace(/^\+/, '')
  }
}

export const phoneToString = telefono => {
  return `${telefono.prefijoInternacional || ''}${telefono.telefono || ''}`
}

export const getPhoneValidationState = telefono => {
  const hasContacto = telefono.nombre && telefono.nombre.trim() !== ''
  const hasTelefono = telefono.telefono && telefono.telefono.trim() !== ''
  const isPhoneValid =
    hasTelefono && isPossiblePhoneNumber(phoneToString(telefono))

  if (hasContacto && isPhoneValid) return 'success'
  if (hasTelefono && !isPhoneValid) return 'error'
  return 'warning'
}

export const isPhoneEntryValid = telefono => {
  return getPhoneValidationState(telefono) === 'success'
}

export const hasValidPhone = telefonos => {
  if (!telefonos || telefonos.length === 0) return false
  return telefonos.some(isPhoneEntryValid)
}

export const countries = countryList
